import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import SliderCotizadores from "../../components/Slider/SliderCotizadores";
import { Container, Col, Row } from "reactstrap";
//import banner from "../../assets/img/social/slide1.png";
import Cabecera from "../../components/Layout/CabeceraHomePublica";

import { contenidosFetch } from "../../redux/actions/aContenidos";

import { encriptarTrama } from "../../utils/Encriptar";
import { loginFetch, limpiarLogin } from "../../redux/actions/aLogin";
import { empresa } from "../../constants";
import { plataforma1 } from "../../constants/urls";

import { ProductosMenuFetch, ServiciosMenuFetch } from "../../redux/actions/aMenus";



class ContainerHomePublica extends Component {

  constructor(props) {
    super(props);
    const userOkta = new URLSearchParams(this.props.location.search).get('user')
    this.state = {
      userFromOkta: userOkta ? atob(userOkta) : undefined,
      ObtenerSeccion1: [],
      ObtenerSeccion2: [],
      ObtenerSeccion3: [],
      ObtenerSeccion4: [],
      ObtenerSeccion5: [],
      banner: "",
    };
  }

  async componentDidMount() {
    // ----------------- Inicia En caso de registre por Okta -----------------
    console.log('user_is', this.state.userFromOkta);
    if (this.state.userFromOkta !== undefined && this.state.userFromOkta !== null && this.state.userFromOkta !== '') {
      const dataLogin = {
        cliUsuario: this.state.userFromOkta,
        // es importante que el string no este vació, pero con contenido no útil, para que funcione bien el servicio
        cliPassword: "_",
        carHash: "",
        autologin: true,
        autoLoginUsuario: true,
      };

      const dataLoginJSON = JSON.stringify(dataLogin);
      const encrypted64Login = encriptarTrama(dataLoginJSON);
      console.log('dataLoginJSON', encrypted64Login);

      await this.props.loginUsuario({
        empresa: empresa,
        plataforma: plataforma1,
        data: encrypted64Login
      });
      // redirigir nuevamente al home
      this.props.history.push({
        pathname: '/'
      })
    }
    // ----------------- Termina En caso de registre por Okta -----------------

    await this.props.obtenerContenido("home");
    console.log('TEST LOADING')
    await this.props.ProductosMenuFetch();




    await this.props.ServiciosMenuFetch();

    if (this.props.datosContenido && this.props.datosContenido.contenidos)
      this.setData();

  }

  setData = () => {
    const { paginas } = this.props.datosContenido.contenidos;
    if (paginas) {
      const ObtenerBanner = paginas.filter(
        (objeto) => parseInt(objeto.seccion) === 0
      );
      const ObtenerSeccion1 = paginas.filter(
        (objeto) => parseInt(objeto.seccion) === 1
      );
      const ObtenerSeccion2 = paginas.filter(
        (objeto) => parseInt(objeto.seccion) === 2
      );
      const ObtenerSeccion3 = paginas.filter(
        (objeto) => parseInt(objeto.seccion) === 3
      );
      const ObtenerSeccion4 = paginas.filter(
        (objeto) => parseInt(objeto.seccion) === 4
      );
      const ObtenerSeccion5 = paginas.filter(
        (objeto) => parseInt(objeto.seccion) === 5
      );

      const banner = ObtenerBanner[0]
        ? ObtenerBanner[0].contenido.url_icono_img
        : "";
      const urlPdf = ObtenerBanner[0].contenido.url_redireccion;

      this.setState({
        ObtenerSeccion1,
        ObtenerSeccion2,
        ObtenerSeccion3,
        ObtenerSeccion4,
        ObtenerSeccion5,
        banner,
        urlPdf,
      });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.datosContenido !== prevProps.datosContenido &&
      this.props.datosContenido.contenidos
    )
      this.setData();
  }

  render() {
    const { carritoVisible } = this.props;

    const {
      ObtenerSeccion1,
      ObtenerSeccion2,
      ObtenerSeccion3,
      ObtenerSeccion4,
      ObtenerSeccion5,
      banner,
      urlPdf,
    } = this.state;

    return (
      <main className="cr-app-home main-bordes">
        <div className="cr-content-home">
          <div>
            <Row>
              <Col md={12}>
                <Cabecera carritoVisible={carritoVisible} userFromOkta={this.state.userFromOkta} />
              </Col>
              <Col md={12}>
                <a href={urlPdf} target="_blank" rel="noopener noreferrer">
                  <img
                    src={banner}
                    alt={""}
                    className={"slide-principal-front"}
                  />
                </a>
              </Col>
            </Row>
          </div>
          <Container>
            <Row>
              <Col md={12}>
                <div className={"titulo-home-padding"}>
                  <div className={"titulos-texto-home"}>
                    {ObtenerSeccion1[0]
                      ? ObtenerSeccion1[0].contenido.titulo
                      : ""}
                  </div>
                  <div className={"titulos-texto-descripcion"}>
                    {ObtenerSeccion1[0]
                      ? ObtenerSeccion1[0].contenido.texto
                      : ""}
                  </div>
                </div>
              </Col>
              <Col md={12}>
                <div className={"titulo-home-padding"}>
                  <div className={"titulos-texto-home"}>
                    {ObtenerSeccion2[0]
                      ? ObtenerSeccion2[0].contenido.titulo
                      : ""}
                  </div>
                </div>
                {this.props.datosContenido.slidersHome && <SliderCotizadores key={`sliders${this.props.datosContenido.slidersHome.length}`} sliders={this.props.datosContenido.slidersHome}/>}
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <div className={"titulo-home-padding"}>
                  <div className={"titulos-texto-home"}>
                    {ObtenerSeccion3[0]
                      ? ObtenerSeccion3[0].contenido.titulo
                      : ""}
                  </div>
                </div>
              </Col>
              <Col md={12}>
                <Row>
                  <Col md={6}>
                    <div className={"descripcion-usuarios-home"}>
                      {ObtenerSeccion3[0]
                        ? ObtenerSeccion3[0].contenido.texto
                        : ""}
                    </div>
                  </Col>
                  <Col md={6}>
                    <img
                      src={
                        ObtenerSeccion3[0]
                          ? ObtenerSeccion3[0].contenido.url_icono_img
                          : ""
                      }
                      alt={""}
                      className={"img-usuarios-home"}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <img
                  src={
                    ObtenerSeccion4[0]
                      ? ObtenerSeccion4[0].contenido.url_icono_img
                      : ""
                  }
                  alt={""}
                  className={"img-modernos-home"}
                />
              </Col>

              <Col md={12}>
                <Row style={{ paddingBottom: "2em" }}>
                  <Col lg={3} xs={6}>
                    <img
                      src={
                        ObtenerSeccion5[0]
                          ? ObtenerSeccion5[0].contenido.url_icono_img
                          : ""
                      }
                      alt={""}
                      className={"img-info-home"}
                    />
                    <div>
                      <div style={{ textAlign: "center" }}>
                        <div
                          className={"titulos-texto-descripcion"}
                          style={{ fontWeight: "bold" }}
                        >
                          {ObtenerSeccion5[0]
                            ? ObtenerSeccion5[0].contenido.titulo
                            : ""}
                        </div>
                      </div>
                    </div>
                    <div className={"texto-descripcion-justify"}>
                      <p>
                        {ObtenerSeccion5[0]
                          ? ObtenerSeccion5[0].contenido.texto
                          : ""}
                      </p>
                    </div>
                  </Col>
                  <Col lg={3} xs={6}>
                    <img
                      src={
                        ObtenerSeccion5[1]
                          ? ObtenerSeccion5[1].contenido.url_icono_img
                          : ""
                      }
                      alt={""}
                      className={"img-info-home"}
                    />
                    <div style={{ textAlign: "center" }}>
                      <div
                        className={"titulos-texto-descripcion"}
                        style={{ fontWeight: "bold" }}
                      >
                        <p>
                          {ObtenerSeccion5[1]
                            ? ObtenerSeccion5[1].contenido.titulo
                            : ""}
                        </p>
                      </div>
                    </div>
                    <div className={"texto-descripcion-justify"}>
                      <p>
                        {ObtenerSeccion5[1]
                          ? ObtenerSeccion5[1].contenido.texto
                          : ""}
                      </p>
                    </div>
                  </Col>
                  <Col lg={3} xs={6}>
                    <img
                      src={
                        ObtenerSeccion5[2]
                          ? ObtenerSeccion5[2].contenido.url_icono_img
                          : ""
                      }
                      alt={""}
                      className={"img-info-home"}
                    />
                    <div style={{ textAlign: "center" }}>
                      <div
                        className={"titulos-texto-descripcion"}
                        style={{ fontWeight: "bold" }}
                      >
                        <p>
                          {ObtenerSeccion5[2]
                            ? ObtenerSeccion5[2].contenido.titulo
                            : ""}
                        </p>
                      </div>
                    </div>
                    <div className={"texto-descripcion-justify"}>
                      <p>
                        {ObtenerSeccion5[2]
                          ? ObtenerSeccion5[2].contenido.texto
                          : ""}
                      </p>
                    </div>
                  </Col>
                  <Col lg={3} xs={6}>
                    <img
                      src={
                        ObtenerSeccion5[3]
                          ? ObtenerSeccion5[3].contenido.url_icono_img
                          : ""
                      }
                      alt={""}
                      className={"img-info-home"}
                    />
                    <div style={{ textAlign: "center" }}>
                      <div
                        className={"titulos-texto-descripcion"}
                        style={{ fontWeight: "bold" }}
                      >
                        <p>
                          {ObtenerSeccion5[3]
                            ? ObtenerSeccion5[3].contenido.titulo
                            : ""}
                        </p>
                      </div>
                    </div>
                    <div className={"texto-descripcion-justify"}>
                      <p>
                        {ObtenerSeccion5[3]
                          ? ObtenerSeccion5[3].contenido.texto
                          : ""}
                      </p>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  datosContenido: state.datosContenido,
});

const mapDispatchToProps = (dispatch) => {
  return {
    obtenerContenido: (seccion) => dispatch(contenidosFetch(seccion)),
    ProductosMenuFetch: () => dispatch(ProductosMenuFetch()),
    loginUsuario: dataLogin => dispatch(loginFetch(dataLogin)),
    ServiciosMenuFetch: () => dispatch(ServiciosMenuFetch()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ContainerHomePublica)
);
